import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import directive from './report-package-report.directive';
import controller from './report-package-report.controller';


export default angular.module('app.components.reports.packageReports.reportPackageReport', [
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService,
  actionIcon,
])
  .directive('prReportPackageReport', directive)
  .controller('PRReportPackageReportController', controller)
  .name;

console.log('app.components.reports.packageReports.reportPackageReport created');
